import api, {handleAPIErrors} from 'shared/api'

const UPDATE_REQUEST = 'users/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'users/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'users/UPDATE_FAILURE'
const ADD_USER_REQUEST = 'users/ADD_USER_REQUEST'
const ADD_USER_SUCCESS = 'users/ADD_USER_SUCCESS'
const ADD_USER_FAILURE = 'users/ADD_USER_FAILURE'
const DELETE_USER_REQUEST = 'users/DELETE_USER_REQUEST'
const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS'
const DELETE_USER_FAILURE = 'users/DELETE_USER_FAILURE'

const initialState = {
    user: {},
    adding: false,
    added: false,
    deleting: false,
    deleted: false,
    errors: {}
}

export function addRequest(payload = {}) {
    return {
        type: ADD_USER_REQUEST,
    }
}

export function addSuccess(payload) {
    return {
        type: ADD_USER_SUCCESS,
        payload,
    }
}

export function addFailure(errors = []) {
    return {
        type: ADD_USER_FAILURE,
        errors,
    }
}

export function deleteRequest(payload = {}) {
    return {
        type: DELETE_USER_REQUEST,
    }
}

export function deleteSuccess(payload) {
    return {
        type: DELETE_USER_SUCCESS,
        payload,
    }
}

export function deleteFailure(errors = []) {
    return {
        type: DELETE_USER_FAILURE,
        errors,
    }
}

export function updateRequest(payload = {}) {
    return {
        type: UPDATE_REQUEST,
    }
}

export function updateSuccess(payload) {
    return {
        type: UPDATE_SUCCESS,
        payload,
    }
}

export function updateFailure(errors = []) {
    return {
        type: UPDATE_FAILURE,
        errors,
    }
}

export function addUser(options, cb) {
    const config = {
        method: 'POST',
        body: JSON.stringify(options)
    }

    return (dispatch) => {
        dispatch(addRequest())

        return api(`api/v1/users/add_user`, {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(addSuccess(json))

                cb()
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(addFailure(errors))
                })
            })
    }
}

export function removeUser(id) {
    const config = {
        method: 'DELETE'
    }

    return (dispatch) => {
        dispatch(deleteRequest())

        return api(`api/v1/users/remove_user`, {id: id}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(deleteSuccess(json))
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(deleteFailure(errors))
                })
            })
    }
}

export function updateSubscription(user, createAction = true, callback) {
    const config = {
        method: 'POST',
        body: JSON.stringify({
            user,
        }),
    }
    const url = createAction ? '' : 'upgrade'

    return (dispatch) => {
        dispatch(updateRequest())

        const promise = api(`/api/v1/subscriptions/${url}`, {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(updateSuccess(json))

                if (callback) callback(json)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(updateFailure(errors))
                })
            })

        return promise
    }
}

export function cancelSubscription(callback) {
    const config = {
        method: 'POST',
    }

    return (dispatch) => {
        dispatch(updateRequest())

        const promise = api('/api/v1/subscriptions/cancel', {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(updateSuccess(json))

                if (callback) callback(json)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(updateFailure(errors))
                })
            })

        return promise
    }
}

export function toggleSubscriptionAutoRenewal(callback) {
    const config = {
        method: 'POST',
    }

    return (dispatch) => {
        dispatch(updateRequest())

        const promise = api('/api/v1/subscriptions/toggle_auto_renewal', {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(updateSuccess(json))

                if (callback) callback(json)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(updateFailure(errors))
                })
            })

        return promise
    }
}

export function updatePaymentAccount(card_token, callback) {
    const config = {
        method: 'POST',
        body: JSON.stringify({
            card_token,
        }),
    }

    return (dispatch) => {
        dispatch(updateRequest())

        return api('/api/v1/subscriptions/update_payment_account', {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(updateSuccess(json))

                if (callback) callback(json)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(updateFailure(errors))
                })
            })
    }
}

export function updatePassword(password, callback) {
    const config = {
        method: 'POST',
        body: JSON.stringify({
            password,
        }),
    }

    return (dispatch) => {
        dispatch(updateRequest())

        const promise = api('/api/v1/users/change_password', {}, config)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(updateSuccess(json))

                if (callback) callback(json)
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(updateFailure(errors))
                })
            })

        return promise
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const {payload, type, errors} = action

    switch (type) {
        case ADD_USER_REQUEST:
            return Object.assign({}, state, {
                adding: true,
            })
        case ADD_USER_SUCCESS:
            return Object.assign({}, state, {
                adding: false,
                added: true,
                errors: {},
                user: payload
            })
        case ADD_USER_FAILURE:
            return Object.assign({}, state, {
                added: false,
                adding: false,
                errors,
            })
        case DELETE_USER_REQUEST:
            return Object.assign({}, state, {
                deleting: true,
            })
        case DELETE_USER_SUCCESS:
            return Object.assign({}, state, {
                deleting: false,
                deleted: true,
                errors: {},
                user: payload
            })
        case DELETE_USER_FAILURE:
            return Object.assign({}, state, {
                deleted: false,
                deleting: false,
                errors,
            })
        case UPDATE_REQUEST:
            return Object.assign({}, state, {
                updating: true,
            })
        case UPDATE_SUCCESS:
            return Object.assign({}, state, {
                updating: false,
                errors: {},
                user: payload
            })
        case UPDATE_FAILURE:
            return Object.assign({}, state, {
                updating: false,
                errors,
            })
        default:
            return state
    }
}

